import { c as _c } from "react/compiler-runtime";
export const LoadingSkeletons = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><div className="bg-light-grey animate-pulse h-7 w-24 [border-radius:8px]" /><div className="bg-light-grey animate-pulse h-7 w-32 [border-radius:8px]" /><div className="bg-light-grey animate-pulse h-7 w-28 [border-radius:8px]" /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};